<template>
  <article class="download-file">
    <a v-bind:href="file" target="_blank">
      <span v-html="title"></span>

      <i class="fa fa-download"></i>
      <!-- /.fa fa-download -->
    </a>
  </article>
  <!-- /.download-file -->
</template>

<script>
  export default {
    name: 'Arquivo',
    props: {
      title: String,
      file: String
    }
  };
</script>

<style scoped lang="scss">
  .download-file {
    & + .download-file {
      margin-top: 10px;
    }

    a {
      position: relative;

      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 30px 15px 10px;

      font-family: 'Lato', sans-serif;
      color: #333333;
      text-decoration: none;
      line-height: 1.2;

      background-color: #ffffff;
      border: 1px solid #f1f1f1;
      border-radius: 5px;
      box-shadow: 0 0 40px -20px #1d2124;

      transition: .3s ease-in-out;

      &:hover {
        color: #ffffff;

        background-color: #7a2722;

        i {
          transform: scale(2) translateY(-20%);
        }
      }
    }

    i {
      position: absolute;
      top: 50%;
      right: 20px;

      transform: translateY(-50%);
      transition: transform .2s ease-in-out;
    }
  }
</style>
